import LockOutlined from '@mui/icons-material/LockOutlined';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type DataPlusEntitlementModalProps = {
  /** Feature label woven into the copy, e.g. "Retention" / "Benchmarks". */
  featureName: string;
  'data-testid'?: string;
};

/**
 * The Data Plus paywall card shown over a blurred preview when the client is not
 * entitled. Purely presentational; the Upgrade CTA is a placeholder until
 * product wires its destination.
 */
const DataPlusEntitlementModal = ({
  featureName,
  'data-testid': dataTestId = 'GuestJourney.DataPlus.Modal',
}: DataPlusEntitlementModalProps) => {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={8}
      data-testid={dataTestId}
      sx={{ p: 4, maxWidth: 420, textAlign: 'center', borderRadius: 2 }}
    >
      <Stack spacing={2} alignItems="center">
        <LockOutlined color="primary" fontSize="large" />
        <Typography variant="h2">
          {t('page.guestJourney.dataPlus.title', { feature: featureName })}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('page.guestJourney.dataPlus.description', {
            feature: featureName,
          })}
        </Typography>
        <Button variant="contained" data-testid={`${dataTestId}.Upgrade`}>
          {t('page.guestJourney.dataPlus.upgrade')}
        </Button>
        <Typography variant="caption" color="text.secondary">
          {t('page.guestJourney.dataPlus.contact')}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default DataPlusEntitlementModal;
